import React, { useState } from "react";

const ServiceTabs = () => {
  const [activeTab, setActiveTab] = useState("included");

  return (
    <div className="w-full max-w-5xl mx-auto px-4">
      {/* Tabs */}
      <div className="flex flex-wrap justify-center border-b border-gray-300">
        {[
          { id: "included", label: "What's Included" },
          { id: "quality", label: "No Compromises on Quality" },
          { id: "custom", label: "Customized Solutions" },
        ].map((tab) => (
          <button
            key={tab.id}
            className={`px-4 py-2 text-sm md:text-base font-semibold transition ${
              activeTab === tab.id
                ? "text-[#063970] border-b-2 border-[#063970]"
                : "text-gray-600 hover:text-[#063970]"
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="mt-6 text-gray-700 text-base leading-relaxed">
        {activeTab === "included" && (
          <div className="space-y-4">
            <p><b>Product and Project Development:</b> Our architects and designers collaborate with you to create layouts that match your preferences, lifestyle, and budget.</p>
            <p><b>Material Prescription:</b> We use carefully sourced materials and expert craftsmanship for durability and safety.</p>
            <p><b>Project Management:</b> A dedicated manager provides transparent updates and complete control at every stage.</p>
            <p><b>Installation:</b> We handle construction and installation with precision for a smooth process.</p>
          </div>
        )}

        {activeTab === "quality" && (
          <div className="space-y-4">
            <p><b>High Standards:</b> Every project undergoes strict quality checks to ensure safety and excellence.</p>
            <p><b>Premium Materials:</b> From foundation to finishing, we use only the best construction-grade materials.</p>
            <p><b>Skilled Workforce:</b> Our trained professionals deliver precision and attention to detail on every task.</p>
          </div>
        )}

        {activeTab === "custom" && (
          <div className="space-y-4">
            <p><b>Tailored Designs:</b> We adapt services to your unique vision, style, and requirements.</p>
            <p><b>Flexible Solutions:</b> From residential to industrial, we provide personalized strategies for every project.</p>
            <p><b>Client-Centered Approach:</b> We listen closely and deliver results that align with your needs.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceTabs;
